/** 本文件由工具自动生成,请勿手动修改！ **/
// @ts-nocheck
import { useState,  useEffect } from 'react';
import * as R from 'ramda';
import Request, { YWRequestConfig } from '@ywfe/request';
import { getHost, reduceParams, parseParams, querystring } from '@ywfe/utils';


const { basePath = '', loginPath = '' } = getHost("PRO_SETTLE", "446")




export interface API56322Req {
  
  /** 任务id */
  taskId?: number;
};



export interface API56322Res {
  /**   */
  code?: string;
  /**   */
  msg?: string;
  /**   */
  success?: boolean;
  /** data  */
  data?: boolean;
  /**   */
  exceptionMsg?: string;
  
};


// 56322 接受任务

export interface IUsePostAPI56322Return {
  /** 接受任务: 接口请求状态 */
  isAPI56322Loading: boolean;
  /** 接受任务: 接口请求返回数据 */
  dataAPI56322: API56322Res;
  /**  接受任务: 接口数据请求方法 */
  fetchAPI56322Data:  (inputs: API56322Req, config?: YWRequestConfig) => Promise<API56322Res>;
  /** 接受任务: 接口请求URL */
  requestUrl: string;
}

export const usePostAPI56322 = ():IUsePostAPI56322Return => {
  let isMount = true;
  const [isAPI56322Loading, setIsAPI56322Loading] = useState(false);
  const [dataAPI56322, setDataAPI56322] = useState<API56322Res>({} as API56322Res);
  const requestUrl = `${basePath}/team-work/workTask/receiveTask`;

  const fetchAPI56322Data = async (inputs: API56322Req, config?: YWRequestConfig): Promise<API56322Res> => {
  
    
    const params = (reduceParams(inputs as unknown as R.Dictionary<API56322Req>) || {}) as API56322Req;
    
  
    if ( isMount ) {
      setIsAPI56322Loading(true);
    }

    try {
      
      
      
      const res: any = await Request.post<API56322Res>(`${basePath}/team-work/workTask/receiveTask`, params, {
        loginHost: loginPath,
        ...config
      });
      
      
      if (isMount) {
        setDataAPI56322(res || {} as API56322Res);
        setIsAPI56322Loading(false);
      }
      return res;
    } catch (error) {
      console.error('[ERROR] API Request Error: ', error);
      if ( isMount ) {
        setIsAPI56322Loading(false);
      }
      return false as unknown as API56322Res;
    }
  }

  useEffect(() => {
    return () => {
      isMount = false;
    };
  }, []);

  return {
    isAPI56322Loading,
    dataAPI56322,
    fetchAPI56322Data,
    requestUrl,
  }
}

